import { MapPin, Ruler, Bath, Bed, Shield, TrendingUp, Clock } from "lucide-react";
import { Progress } from "@/components/ui/progress";
import type { Tables } from "@/integrations/supabase/types";

interface PropertyDetailsProps {
  property: Tables<"real_estate_properties">;
}

export const PropertyDetails = ({ property }: PropertyDetailsProps) => {
  return (
    <>
      <h3 className="text-xl font-semibold mb-2 group-hover:text-primary transition-colors">
        {property.title}
      </h3>
      <div className="flex items-center text-muted-foreground mb-4">
        <MapPin className="h-4 w-4 mr-1" />
        <span className="text-sm">{property.location}</span>
      </div>
      <div className="grid grid-cols-2 gap-4 mb-4">
        <div className="flex items-center">
          <Ruler className="h-4 w-4 mr-1 text-primary" />
          <span className="text-sm">{property.size_sqm} sqm</span>
        </div>
        {property.property_type === 'home' && (
          <>
            <div className="flex items-center">
              <Bed className="h-4 w-4 mr-1 text-primary" />
              <span className="text-sm">{property.bedrooms} beds</span>
            </div>
            <div className="flex items-center">
              <Bath className="h-4 w-4 mr-1 text-primary" />
              <span className="text-sm">{property.bathrooms} baths</span>
            </div>
          </>
        )}
        {property.collateral_value && (
          <div className="flex items-center">
            <Shield className="h-4 w-4 mr-1 text-primary" />
            <span className="text-sm">Collateral eligible</span>
          </div>
        )}
      </div>
      {property.funding_goal && (
        <div className="space-y-2 mb-4">
          <div className="flex justify-between text-sm">
            <span>Investment Progress</span>
            <span className="font-medium">
              {((property.funding_progress || 0) / property.funding_goal * 100).toFixed(1)}%
            </span>
          </div>
          <Progress value={(property.funding_progress || 0) / property.funding_goal * 100} />
          <div className="flex justify-between text-sm text-muted-foreground">
            <span>GHS {property.funding_progress?.toLocaleString()}</span>
            <span>GHS {property.funding_goal.toLocaleString()}</span>
          </div>
        </div>
      )}
      <div className="grid grid-cols-2 gap-4 mb-4">
        {property.expected_returns && (
          <div className="flex items-center">
            <TrendingUp className="h-4 w-4 mr-1 text-primary" />
            <span className="text-sm">
              {property.expected_returns}% Expected Returns
            </span>
          </div>
        )}
        {property.investment_term_months && (
          <div className="flex items-center">
            <Clock className="h-4 w-4 mr-1 text-primary" />
            <span className="text-sm">
              {property.investment_term_months} Month Term
            </span>
          </div>
        )}
      </div>
    </>
  );
};